/* 
    날짜    : 2020.03.10.
    작성자  : 윤태진
    기능    : print module
*/
const state = {
  browser_key:
    "<OBJECT ID='previewWeb' WIDTH=0 HEIGHT=0 CLASSID='CLSID:8856F961-340A-11D0-A96B-00C04FD705A2'></OBJECT>",
  browser: null
};
const actions = {
  /* 브라우저 체크 */
  checkBrowser({ commit }) {
    let word = "";
    let info = { name: "N/A", version: -1 };
    let agent = navigator.userAgent.toLowerCase();

    if (agent.indexOf("chrome") != -1) {
      /* chrome */
      info.name = "chrome";
    } else if (agent.search("trident") != -1) {
      /* IE */
      word = "trident/.*rv:";
      let reg = new RegExp(word + "([0-9]{1,})(\\.{0,}[0-9]{0,1})");

      if (reg.exec(agent) != null) {
        info.version = parseFloat(RegExp.$1 + RegExp.$2);
        info.name = word == "edge/" ? "Edge" : "IE";
      }
      if (info.name == "IE" && info.version == "11") {
        info.name = "IE";
      }
    }
    commit("setBrowserInfo", info.name);
  },
  /* 프린트 */
  onPrint({ state, dispatch }, dom) {
    dispatch("checkBrowser");

    let browser = state.browser;
    if (browser == "chrome") {
      window.print();
    } else {
      dispatch("onPreview", dom);
    }
  },
  /* IE 미리보기 */
  onPreview({ state }, dom) {
    try {
      /* 웹 페이지에 객체 삽입 */
      dom.insertAdjacentHTML("beforeEnd", state.browser_key);
      /* ExexWB 메쏘드 실행 (7 : 미리보기 , 8 : 페이지 설정 , 6 : 인쇄하기(대화상자)) */
      previewWeb.ExecWB(7, 1);
      previewWeb.outerHTML = ""; /* 객체 해제 */
    } catch (e) {
      console.log(e);
    }
  }
};
const mutations = {
  setBrowserInfo(state, browser) {
    state.browser = browser;
  }
};
const getters = {};

export default { state, actions, mutations, getters, namespaced: true };



// WEBPACK FOOTER //
// ./src/js/store/modules/print.js